import { Box, Button, Checkbox, CircularProgress, FormGroup, Grid, Paper, TextField, Tooltip, Typography } from "@mui/material";
import { Edit } from '@mui/icons-material';
import { PermissionWrapper } from "../../../../wrappers";
import { trackActivity } from "../../../../utils/mixpanel";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { globalGetService, globalPutService } from "../../../../utils/globalApiServices";
import { checkApiStatus } from "../../../../utils";
import { PageLoader } from "../../../../shared_elements";
import { editSubleaseCardApi, getSubleaseCardDetailApi } from "../apiServices";
import { enqueueSnackbar } from "notistack";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";
const SubleaseCardView = () => {
    const { leaseSlug } = useParams();
    const params = { leaseSlug };
    const [isLoading, setLoading] = useState(false);
    const [subleaseCardInfo, setSubleaseCardInfo] = useState({});
    const [prevData, setPrevData] = useState({});
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        getSubleaseCardData();
        trackActivity('Page Viewed', { page_title: 'Sublease Config' })
    }, [])

    const getSubleaseCardData = (loaderType, query = {}) => {
        setLoading(true);
        globalGetService(getSubleaseCardDetailApi(params)).then(response => {
            if (checkApiStatus(response)) {
                setSubleaseCardInfo(response?.data?.data);
            }
            setLoading(false);
        })
    }
    const editSubleaseCardData = () => {
        setLoading(true);
        globalPutService(editSubleaseCardApi(params), subleaseCardInfo).then(response => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                trackActivity('Item Edited', { page_title: `Edit Sub Lease Config`, success_msg: response?.data?.message, lease_id: subleaseCardInfo?.lease, payload: subleaseCardInfo, response: response?.data })
                setEditMode(false);
            }
            setLoading(false);
        })
    }


    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Sublease Config`, page_type: page_type, })
    }
    return (
        <>
            <Paper
                elevation={0}
                sx={{
                    padding: 1,
                    borderRadius: 2,
                    margin: '10px 1px 8px 1px',
                    boxShadow: '1px 1px 3px 1px #BBBBBB'
                }}
            >
                <Grid sx={{ display: 'flex', justifyContent: "end", alignItems: 'center' }} mb={2}>
                    <Grid>
                        <ul className="list-inline" style={{ float: "right", alignItems: "center", display: "flex" }}>
                            <li>
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "sublease", operationType: ['U'] }}>
                                    {!editMode &&
                                        <Tooltip title="Edit">
                                            <Edit fontSize="small" color="primary" sx={{ cursor: 'pointer' }}
                                                onClick={() => { setEditMode(true); setPrevData(subleaseCardInfo); handleItemClicked('Sublease Card EditIcon') }} />
                                        </Tooltip>}
                                </PermissionWrapper>
                            </li>
                        </ul>
                    </Grid>
                </Grid>
                <Grid container spacing={{ xs: 0, md: 2 }}>
                    {editMode ?
                        <Grid size={{ md: 12, xs: 12 }} sx={{ backgroundColor: '#FFFFFF' }}>
                            <TextField
                                id="sublease_comments"
                                value={subleaseCardInfo?.sublease_comments || ''}
                                label="Sub Lease Comment"
                                variant="outlined"
                                onChange={(e) => setSubleaseCardInfo(prev => ({ ...prev, sublease_comments: e.target.value }))}
                                size="small"
                                margin="normal"
                                fullWidth
                                multiline
                                rows={3}
                                slotProps={{ inputLabel: { shrink: true } }}
                                disabled={!editMode}
                                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } , mt: { xs: 0.5, md: 2 }, mb: { xs: 0.5, md: 2 } }}
                            />
                        </Grid>
                        : <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Sub Lease Comment' value={subleaseCardInfo?.sublease_comments || ""} />
                        </Grid>}
                    <Grid size={{ md: 4, xs: 12 }}>
                        <FormGroup className='disabled-checkbox-wrapper'>
                            <Box className="check-item-div" sx={{cursor: !editMode && 'not-allowed'}}>
                                <Checkbox checked={subleaseCardInfo?.right_to_sublease_without_prior_approval === true ? true : false} onChange={(e) => setSubleaseCardInfo(prev => ({ ...prev, right_to_sublease_without_prior_approval: e.target.checked }))} disabled={!editMode} />
                                <Typography className="check-item-span" fontSize='14px'>Right to Sub Lease without prior Approval</Typography>
                            </Box>
                        </FormGroup>
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <FormGroup className='disabled-checkbox-wrapper'>
                            <Box className="check-item-div" sx={{cursor: !editMode && 'not-allowed'}}>
                                <Checkbox checked={subleaseCardInfo?.sublease_fee === true ? true : false} onChange={(e) => setSubleaseCardInfo(prev => ({ ...prev, sublease_fee: e.target.checked }))} disabled={!editMode} />
                                <Typography className="check-item-span" fontSize='14px'>Sub Lease Fee</Typography>
                            </Box>
                        </FormGroup>
                    </Grid>

                </Grid>
                {editMode && (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', py: '6px', }}>
                        <Button className='cancel-btn' onClick={() => { setEditMode(false); setSubleaseCardInfo(prevData); handleItemClicked('Cancel Button') }} sx={{ mr: 1 }} variant="outlined" size="small" disabled={isLoading}>
                            Cancel
                        </Button>
                        <Button className='btn-primary' onClick={() => { handleItemClicked('Save Button'); editSubleaseCardData(); }} variant="contained" size="small">
                            {isLoading ? <CircularProgress color='inherit' size={24} /> : 'Save'}
                        </Button>
                    </Box>
                )}
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default SubleaseCardView;